module.exports = __webpack_public_path__ + "img/Linkedin_footer.33094202.svg";